import React, { useEffect, useState } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { CircularProgress, Box } from '@mui/material';
import authService from '../../services/authService';

interface PrivateRouteProps {
  children: React.ReactNode;
  requiredRoles?: string[];
}

const PrivateRoute: React.FC<PrivateRouteProps> = ({ children, requiredRoles = [] }) => {
  const { isAuthenticated, user, loading: authLoading } = useAuth();
  const location = useLocation();
  const [isChecking, setIsChecking] = useState(true);

  useEffect(() => {
    const checkAuth = async () => {
      try {
        // 認証チェック
        const token = authService.getToken();
        
        if (!token) {
          console.log('PrivateRoute - トークンが存在しません');
          setIsChecking(false);
          return;
        }

        // トークンの有効性をチェック
        const userInfo = authService.getUserInfo();
        if (!userInfo || !userInfo.user) {
          console.log('PrivateRoute - ユーザー情報が無効です');
          setIsChecking(false);
          return;
        }

        console.log('PrivateRoute - 認証チェック完了');
        setIsChecking(false);
      } catch (error) {
        console.error('PrivateRoute - 認証チェックでエラー:', error);
        setIsChecking(false);
      }
    };

    checkAuth();
  }, []);

  // 認証チェック中の場合はローディング表示
  if (authLoading || isChecking) {
    return (
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        minHeight="100vh"
      >
        <CircularProgress />
      </Box>
    );
  }

  // 未認証の場合はログインページにリダイレクト
  if (!isAuthenticated || !authService.getToken()) {
    console.log('PrivateRoute - 未認証のためログインページにリダイレクト');
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // 権限チェック
  if (requiredRoles.length > 0 && user && user.role) {
    const hasRequiredRole = requiredRoles.includes(user.role);
    if (!hasRequiredRole) {
      console.log('PrivateRoute - 必要な権限がありません');
      return <Navigate to="/unauthorized" state={{ from: location }} replace />;
    }
  }

  return <>{children}</>;
};

export default PrivateRoute; 